import { AlertTriangle, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";
import usePlanInfoStore from "@/store/zustand/planInfoStore";
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { getUnexpiredToken, logAxiosError } from "@/utils/utils";
import { useSubscriptionInfo } from "@/hooks/pricing/useSubscriptionInfo";
import { useSession } from "@clerk/clerk-react";

export function PlanBanner() {
  const rawSubscriptionTier = usePlanInfoStore(
    (state) => state.subscriptionTier
  );

  const { session } = useSession();

  const [loadingManage, setLoadingManage] = useState(false);

  const { usingPrompts } = useSubscriptionInfo();

  const onClickManage = async () => {
    if (session) {
      setLoadingManage(true);

      try {
        const supabaseJWT = await getUnexpiredToken(session);
        const res = await axios.post(
          `${
            import.meta.env.VITE_BACKEND_BASE_URL
          }/stripe/create-customer-portal-session`,
          {
            success_url: window.location.href,
            cancel_url: window.location.href,
            return_url: window.location.href,
          },
          {
            headers: {
              Authorization: `Bearer ${supabaseJWT}`,
            },
          }
        );

        if (res.data.url) {
          window.location.href = res.data.url;
        } else {
          toast.error("Failed to create stripe session");
        }
      } catch (error) {
        logAxiosError("Failed to create stripe session", error);
        toast.error("Failed to create stripe session");
      } finally {
        setLoadingManage(false);
      }
    }
  };

  return (
    <div
      className={cn(
        `h-[71px] p-[22px] bg-gradient-to-b from-[#1F1F22] to-[#131519] 
        rounded-[13px] border border-[#6F55F2] flex items-center justify-between`,
        usingPrompts ? "hidden" : ""
      )}
    >
      <div className="flex items-center gap-2 flex-1">
        <AlertTriangle className="w-6 h-6 text-[#EE681F]" />
        <p className="text-base font-normal leading-snug">
          <span className="text-[#9F9FA4]">You're on an </span>
          <span className="text-[#F5F5F6]">
            old{" "}
            {/*
             // @ts-expect-error TS2532 */}
            {rawSubscriptionTier?.charAt(0).toUpperCase() +
              // @ts-expect-error TS2532
              rawSubscriptionTier?.slice(1)}{" "}
            Plan
          </span>
          <span className="text-[#9F9FA4]"> on Tempo.</span>
        </p>
      </div>

      <Button
        onClick={onClickManage}
        disabled={loadingManage}
        size="sm"
        className="!border-solid border-1 border-[#2F3035] hover:border-[#2F3035] hover:bg-background-secondary"
      >
        {loadingManage ? (
          <Loader2 className="size-4 animate-spin mr-1" />
        ) : null}
        <span>Manage plan</span>
      </Button>
    </div>
  );
}
